var map = {
	"./abc_inventory_analysis.svg": "df6a",
	"./aging_stock.svg": "11f7",
	"./bundle_mapping.svg": "37fc",
	"./create_product_from_report.svg": "a4ac",
	"./data_import.svg": "d06b",
	"./dead_stock.svg": "d553",
	"./google_spreadsheet_integration.svg": "dd5b",
	"./inventory_by_store_locations.svg": "33cf",
	"./inventory_forecasting.svg": "e8bb",
	"./inventory_optimization.svg": "0cb5",
	"./inventory_planning_google_spreadsheet.svg": "56fe",
	"./inventory_problem.svg": "6998",
	"./inventory_remaining_days.svg": "8726",
	"./inventory_replenishment.svg": "7a7d",
	"./inventory_tracking.svg": "afddc",
	"./inventory_transfer.svg": "621f",
	"./low_stock_products.svg": "6488",
	"./multi-store-data-combination.svg": "f188",
	"./out_stock_products.svg": "caab",
	"./product_segment.svg": "5dcc",
	"./quickbooks_integration.svg": "f4e5",
	"./reorder_suggestions.svg": "2736",
	"./replenishment_for_bundle_products.svg": "1f68",
	"./replenishment_setting.svg": "9d1a",
	"./report_page_navigation.svg": "8588",
	"./report_page_visualization.svg": "fb94",
	"./sales_analytics.svg": "e499",
	"./sales_by_location.svg": "f131",
	"./sales_inventory_matching.svg": "63eb",
	"./schedule_create.svg": "fccb",
	"./schedule_edit.svg": "886d",
	"./schedule_introduction.svg": "4323",
	"./sell_through_rate.svg": "dfaf",
	"./setting_incoming_inventory.svg": "6767",
	"./setup_low_stock.svg": "f98e",
	"./slow_moving_products.svg": "7252",
	"./stock_availability_rate.svg": "7bdb",
	"./stockout_lost_revenue_analysis.svg": "4390",
	"./transfer_from_warehouse.svg": "39c8",
	"./zero_sales_days_analysis.svg": "50fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dff";